import { Autocomplete, Divider, Grid, TextField, Typography, useMediaQuery } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import popupStyle from '../../../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisAudio.module.scss'
import Required from '../../../../../components/utility/required'
import globalStyles from '../../../../../assets/styles/global.module.scss'
import IconsColor from '../../../../../components/utility/iconsColor'
import style from '../../../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss'
import voiceAgentStyles from "../../../../../assets/styles/componentStyles/voiceAgentStyles/voiceAgent.module.scss";
import { UserContext, UserContextPayload } from '../../../../../context/userContext'
import { IntegrationContext, IntegrationContextPayload } from '../../../../../context/integrationContext'
import { metaIntegrationPhoneNumberDataNew, metaIntegrationWhatsAppDataNew } from '../../../../../models/axiosModel'
import GlobalButton from '../../../../../components/utility/globalButton/button';
import agent from '../../../../../services/api'
import { useVoiceAgentStore } from '../../../../../store/voiceAgentStore'
import { useNavigate, useSearchParams } from 'react-router-dom'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { useGenericStore } from '../../../../../store/genericStore'
import { useShallow } from 'zustand/react/shallow'
import { isWhatsAppIntegration } from '../../../utils'
import { primaryColor } from '../../../../../utils/colors'

interface assignVAPayloadInterface {
    waba_id: string,
    meta_integration_whatsapp_phone_number_id: number
}

const VoiceAgentAssignPopup = () => {
    const [ searchParams ] = useSearchParams();
    const navigate = useNavigate();
    const agentId = searchParams?.get('voice_agent_id');
    const breakPoints = {
        flagTabletScreen: useMediaQuery('(max-width : 768px) and (min-width : 0px)'), 
        largeScreen: useMediaQuery('(max-width : 1600px) and (min-width : 0px)')
    }
    const initialAssignVAPayload = {
        waba_id: "",
        meta_integration_whatsapp_phone_number_id: 0
    }

    const setFlagNewDeploymentPopup = useVoiceAgentStore((state) => state.setFlagNewDeploymentPopup);
    const getVoiceAgentDetailAPI = useVoiceAgentStore((state) => state.getVoiceAgentDetailAPI);

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    const { integrationListNewStructure, setIntegrationListNewStructure, getMetaIntegrationList } = useContext(IntegrationContext) as IntegrationContextPayload;
    const [assignVoiceAgentPayload, setAssignVoiceAgentPayload] = useState<assignVAPayloadInterface>(initialAssignVAPayload)

    const [flagEnableVoiceCallWarning, setFlagEnableVoiceCallWarning] = useState<boolean>(false);
    const [flagSMBNumberWarning, setFlagSMBNumberWarning] = useState<boolean>(false);
    const [flagVoiceAgentAlreadyAssigned, setFlagVoiceAgentAlreadyAssigned] = useState<boolean>(false);

    const getIntegrationListApiCall = async () => {
        const response: any = await getMetaIntegrationList(true);
        if (response.status) {
        } else {
            handleError(response);
        }
    }

    useEffect(() => {
        (async () => {
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
            setIntegrationListNewStructure(null);
            await getIntegrationListApiCall();
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
        })();
    }, []);

    const getVoiceAgentDetailsAPICall = async () => {
        const res = await getVoiceAgentDetailAPI(agentId || "");
        if(!(res.status)){
            handleError(res);
            navigate('/voiceagent')
        }
    }

    const getWhatsAppNumberOptions = () => {
        if (!integrationListNewStructure) return [];

        return integrationListNewStructure.filter(isWhatsAppIntegration)
            .find((waba: metaIntegrationWhatsAppDataNew) => waba.waba_id == assignVoiceAgentPayload.waba_id)
            ?.meta_integration_phone_number_data || [];
    }

    const getWhatsAppNumberValue = () => {
        const options = getWhatsAppNumberOptions();
        return options.find((phoneNumberData: metaIntegrationPhoneNumberDataNew) => phoneNumberData.meta_integration_whatsapp_phone_number_id === assignVoiceAgentPayload.meta_integration_whatsapp_phone_number_id) || null;
    }

    const getSelectedWABA = () => {
        if(integrationListNewStructure){
            return integrationListNewStructure?.filter(isWhatsAppIntegration)?.find((waba: metaIntegrationWhatsAppDataNew) => waba?.waba_id == assignVoiceAgentPayload?.waba_id);
        }
        return null;
    }

    const resetWarningFlags = () => {
        setFlagEnableVoiceCallWarning(false);
        setFlagSMBNumberWarning(false);
        setFlagVoiceAgentAlreadyAssigned(false);
    }

    const onChangeOfWBA = (value: metaIntegrationWhatsAppDataNew | null) => {
        if (assignVoiceAgentPayload.meta_integration_whatsapp_phone_number_id) {
            setAssignVoiceAgentPayload((prev) => ({
                ...prev,
                meta_integration_whatsapp_phone_number_id: 0,
            }))
        }
        setAssignVoiceAgentPayload((prev) => ({
            ...prev,
            waba_id: value?.waba_id || "",
        }));
        resetWarningFlags();
    }

    const getAssignedVoiceAgents = async (meta_integration_whatsapp_phone_number_id: number) => {
        if (!meta_integration_whatsapp_phone_number_id) {
            setFlagVoiceAgentAlreadyAssigned(false);
            return;
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await agent.getVoiceAgentAssignment.get(meta_integration_whatsapp_phone_number_id);
        if(!(res?.status)){
            handleError(res);
            setFlagVoiceAgentAlreadyAssigned(false);
        } else {
            setFlagVoiceAgentAlreadyAssigned(Boolean(res?.data?.is_assigned));
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    const onChangeOfPhoneNumber = (value: metaIntegrationPhoneNumberDataNew | null) => {
        setAssignVoiceAgentPayload((prev) => ({
            ...prev,
            meta_integration_whatsapp_phone_number_id: value ? value.meta_integration_whatsapp_phone_number_id : 0,
        }));
        resetWarningFlags();
        if (value?.meta_integration_whatsapp_phone_number_id) {
            getAssignedVoiceAgents(Number(value.meta_integration_whatsapp_phone_number_id));
        }
    }

    const handleAssignAgent = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const payload = {
            voice_agent_id: agentId || "",
            meta_integration_whatsapp_phone_number_id: assignVoiceAgentPayload?.meta_integration_whatsapp_phone_number_id,
            flag_assign: true
        }
        const res = await agent.assignVoiceAgent.put(payload);
        if (res?.status) {
            showSuccess("Voice Agent Deployed to WABA.")
            setFlagNewDeploymentPopup(false);
            await getVoiceAgentDetailsAPICall();
        }
        else {
            handleError(res);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    const isAssignAgentDisabled = () => {
        if (assignVoiceAgentPayload?.waba_id?.trim() == "" || assignVoiceAgentPayload?.meta_integration_whatsapp_phone_number_id == 0) {
            return true
        }
        const selectedPhoneNumber = getWhatsAppNumberValue();

        const isSMBNumber = selectedPhoneNumber?.flag_smb_phone_number ?? false;
        
        const isVoiceCallingDisabled = !selectedPhoneNumber?.flag_enable_calling;

        const showSMBNumberWarning = Boolean(isSMBNumber);
        const showEnableVoiceCallWarning = !showSMBNumberWarning && isVoiceCallingDisabled;

        if(flagSMBNumberWarning !== showSMBNumberWarning){
            setFlagSMBNumberWarning(showSMBNumberWarning);
        }

        if (flagEnableVoiceCallWarning !== showEnableVoiceCallWarning) {
            setFlagEnableVoiceCallWarning(showEnableVoiceCallWarning);
        }

        return showSMBNumberWarning || showEnableVoiceCallWarning || flagVoiceAgentAlreadyAssigned;
    }

    const handleCancel = () => {
        setAssignVoiceAgentPayload(initialAssignVAPayload);
        setFlagNewDeploymentPopup(false);
    }

    return (
        <Grid container direction={"column"} gap={"20px"} padding={"25px 30px 30px 30px"} sx={{ zIndex: "1" }}>
            <Grid item sx={{ width: "100%" }} textAlign={"center"}>
                <span className={popupStyle.popupTitleStyle}>Deploy Voice Agent to WABA</span>
            </Grid>
            <Grid item>
                <Divider className={popupStyle.dividerStyles} />
            </Grid>
            <Grid item xs={12}>
                <Grid container gap={2}>
                    <Grid item xs={12}>
                        <Grid container direction={"column"} gap={"10px"}>
                            <Grid item xs={12}>
                                <Grid container justifyContent={"space-between"} alignItems={"center"}>
                                    <Grid item>
                                        <Typography className={style.whatsappCampaignTitleTypography}>WhatsApp Business Account <Required /></Typography>
                                    </Grid>
                                    <Grid item>
                                        <Grid container gap={"8px"} alignItems={"center"} className={globalStyles.clickable} onClick={() => window.open("/channels/viewintegration/whatsapp", "_blank")}>
                                            <IconsColor iconName="plus" width="14" height="14" fillColor={primaryColor} />
                                            {!breakPoints.flagTabletScreen &&
                                                <Grid item><Typography className={style.whatsappCampaignPurpleTitleTypography}>Business Account</Typography></Grid>
                                            }
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Autocomplete
                                    className={style.whatsappCampaignDropDowns}
                                    options={integrationListNewStructure ? integrationListNewStructure.filter(isWhatsAppIntegration) : []}
                                    getOptionLabel={(option: metaIntegrationWhatsAppDataNew) => option.waba_name ? option.waba_name : "WhatsApp Account"}
                                    value={getSelectedWABA()}
                                    onChange={(_, value: metaIntegrationWhatsAppDataNew | null) => { onChangeOfWBA(value); }}
                                    renderInput={(params) => <TextField {...params} placeholder="Select WhatsApp Business Account" />}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Grid container direction={"column"} gap={"10px"}>
                            <Grid item xs={12}>
                                <Typography className={style.whatsappCampaignTitleTypography}>WhatsApp Number <Required /></Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Autocomplete
                                    className={style.whatsappCampaignDropDowns}
                                    options={getWhatsAppNumberOptions()}
                                    getOptionLabel={(option) => option.display_phone_number}
                                    value={getWhatsAppNumberValue()}
                                    onChange={(_, value: metaIntegrationPhoneNumberDataNew | null) => { onChangeOfPhoneNumber(value); }}
                                    renderInput={(params) => <TextField {...params} placeholder="Select WhatsApp Number" />}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    
                    {(flagEnableVoiceCallWarning || flagSMBNumberWarning || flagVoiceAgentAlreadyAssigned) && 
                        <Grid item xs={12}>
                            <Grid container gap={1} className={voiceAgentStyles.enableVoiceCallWarningGrid}>
                                <Grid item className={globalStyles.displayFlexStyle}>
                                    <ErrorOutlineOutlinedIcon className={voiceAgentStyles.enableVoiceCallWarningIcon} />
                                </Grid>
                                <Grid item>
                                    <Typography className={`${globalStyles.tertiaryFontSize} ${globalStyles.secondaryFontWeight} ${voiceAgentStyles.enableVoiceCallWarningTitle}`}>
                                        {flagSMBNumberWarning ?
                                            `Deployment of the voice agent on a WhatsApp Business App (SMB) number is not allowed.`
                                            :
                                            flagEnableVoiceCallWarning ?
                                            <> 
                                                Please{' '}
                                                <a
                                                    href={`/channels/viewintegration/whatsapp/phonenumbers?id=${getSelectedWABA()?.meta_integration_whatsapp_id ?? ""}`}
                                                    target='_blank'
                                                    rel="noopener noreferrer"
                                                >
                                                    enable voice calling
                                                </a>{' '}
                                                for this phone number before proceeding with the agent deployment.
                                            </>
                                            :
                                            `Another Voice Agent is already deployed on this phone number.`
                                        }
                                    </Typography>
                                </Grid>        
                            </Grid>
                        </Grid>
                    }

                </Grid>
            </Grid>
            <Grid item xs={12} mt={1}>
                <Grid container direction={"row"} gap={2} justifyContent={"center"}>
                    <Grid item>
                        <GlobalButton buttonText={"Cancel"} className='borderedButtonStyle' sx={{ minWidth: "130px", fontSize: breakPoints.largeScreen ? "13px !important" : "" }} onClick={() => handleCancel()} />
                    </Grid>
                    <Grid item>
                        <GlobalButton
                            buttonText={"Deploy"}
                            className='primaryButtonStyle'
                            sx={{ minWidth: "130px" }}
                            onClick={handleAssignAgent}
                            disabled={isAssignAgentDisabled()}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default VoiceAgentAssignPopup
